import { ReduxActionType } from 'types';
interface OrgActionType {
  FETCH_USERS_BY_ORG_ID_START: ReduxActionType;
  FETCH_USERS_BY_ORG_ID_SUCCESS: ReduxActionType;
  FETCH_USERS_BY_ORG_ID_FAILURE: ReduxActionType;

  ADD_USERS_TO_ORG_START: ReduxActionType;
  ADD_USERS_TO_ORG_SUCCESS: ReduxActionType;
  ADD_USERS_TO_ORG_FAILURE: ReduxActionType;

  DELETE_USERS_TO_ORG_START: ReduxActionType;
  DELETE_USERS_TO_ORG_SUCCESS: ReduxActionType;
  DELETE_USERS_TO_ORG_FAILURE: ReduxActionType;

  OPEN_ADD_ADMINISTRATOR_MODAL_START: ReduxActionType;

  REMOVE_ERROR: ReduxActionType;

  RESET_USER_ADDED_FLAG: ReduxActionType;
  RESET_USER_DELETED_FLAG: ReduxActionType;
}

export const OrganisationUserActionTypes: OrgActionType = {
  FETCH_USERS_BY_ORG_ID_START: '@@FETCH_USERS_BY_ORG_ID_START',
  FETCH_USERS_BY_ORG_ID_SUCCESS: '@@FETCH_USERS_BY_ORG_ID_SUCCESS',
  FETCH_USERS_BY_ORG_ID_FAILURE: '@@FETCH_USERS_BY_ORG_ID_FAILURE',

  ADD_USERS_TO_ORG_START: '@@_ADD_USERS_TO_ORG_START',
  ADD_USERS_TO_ORG_SUCCESS: '@@ADD_USERS_TO_ORG_SUCCESS',
  ADD_USERS_TO_ORG_FAILURE: '@@ADD_USERS_TO_ORG_FAILURE',

  OPEN_ADD_ADMINISTRATOR_MODAL_START: '@@OPEN_ADD_ADMINISTRATOR_MODAL_START',

  DELETE_USERS_TO_ORG_START: '@@_DELETE_USERS_TO_ORG_START',
  DELETE_USERS_TO_ORG_SUCCESS: '@@DELETE_USERS_TO_ORG_SUCCESS',
  DELETE_USERS_TO_ORG_FAILURE: '@@DELETE_USERS_TO_ORG_FAILURE',

  REMOVE_ERROR: '@@REMOVE_ERROR',

  RESET_USER_ADDED_FLAG: '@@RESET_USER_ADDED_FLAG',
  RESET_USER_DELETED_FLAG: '@@RESET_USER_DELETED_FLAG'
};
export interface OrganisationUser {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  lastLoggedInAt: string;
  role?: string;
}
export interface OrganisationUserState {
  errors: string | null;
  users: Array<OrganisationUser>;
  loadingUsers: boolean;
  isModelOpen: boolean | string;
  isDeleting: boolean;
  submitting: boolean;
  success: boolean;
  userAdded: boolean;
  userDeleted: boolean;
}
export interface AddUserRequest {
  // request from OrganisationUsers/index.tsx
  firstName: string;
  lastName: string;
  email: string;
  orgId: string;
  role?: string;
}
export interface DeleteUserRequest {
  orgId: string;
  id: string; // id of user to be deleted
}
export interface RemoveError {
  id: string; // id of the error that needs to be cleaned
}
